import './App.css';
import { Router } from './router';

function App() {
  return <Router dev={false} basename="/" />;
}

export default App;
